import React from 'react';
import { message, Modal } from 'antd';
import './index.css';
import { ROLE_CODE } from '../../../variable';
import { inject, observer } from 'mobx-react';

@inject('investorStore', 'projectSideStore', 'userStore') // 如果注入多个store，用数组表示
@observer
class ChooseRole extends React.Component {
  state = {
    role: ROLE_CODE.projectSide
  };

  isChoosing = false;

  onChooseProjectSide = () => {
    if (this.isChoosing) {
      message.error('正在发送请求，请稍候');
      return;
    }
    this.isChoosing = true;
    this.setState({ role: ROLE_CODE.projectSide });
    Modal.confirm({
      centered: true,
      maskClosable: true,
      content: '一旦选择就不可更改，确认选择项目方？',
      onOk: () => {
        this.props.projectSideStore
          .fetchChooseRole()
          .then(result => {
            if (result.success) {
              message.success('选择成为 项目方');
              this.onChooseSuccess();
            } else {
              message.error(result.msg);
            }
          })
          .finally(() => {
            this.isChoosing = false;
          });
      }
    });
  };

  onChooseInvestor = () => {
    if (this.isChoosing) {
      message.error('正在发送请求，请稍候');
      return;
    }
    this.isChoosing = true;
    this.setState({ role: ROLE_CODE.investor });
    Modal.confirm({
      centered: true,
      maskClosable: true,
      content: '一旦选择就不可更改，确认选择投资方？',
      onOk: () => {
        this.props.investorStore
          .fetchChooseRole()
          .then(result => {
            if (result.success) {
              message.success('选择成为 投资方');
              this.onChooseSuccess();
            } else {
              message.error(result.msg);
            }
          })
          .finally(() => {
            this.isChoosing = false;
          });
      }
    });
  };

  onChooseSuccess = () => {
    this.props.userStore.fetchUserInfo().then(result => {
      if (result.success) {
        this.props.history.replace('/finance');
      } else {
        message.error(result.msg);
      }
    });
  };

  render() {
    const { role } = this.state;
    const isProjectActive = role === ROLE_CODE.projectSide ? 'active' : '';
    const isInvestorActive = role === ROLE_CODE.investor ? 'active' : '';
    return (
      <div className="choose-role-page">
        <div className="content">
          <div className="skew-back">
            <div className="welcome">请选择您的身份</div>

            <div className="select-area">
              <div className="role-box" onClick={this.onChooseProjectSide}>
                <i className={`iconfont avatar-icon ${isProjectActive}`}>
                  &#xe602;
                </i>
                <div className={`btn ${isProjectActive}`}>
                  项目方
                  {isProjectActive && (
                    <i className="iconfont check-icon">&#xe60a;</i>
                  )}
                </div>
              </div>

              <div className="role-box" onClick={this.onChooseInvestor}>
                <i className={`iconfont avatar-icon ${isInvestorActive}`}>
                  &#xe60d;
                </i>
                <div className={`btn ${isInvestorActive}`}>
                  投资方
                  {isInvestorActive && (
                    <i className="iconfont check-icon">&#xe60a;</i>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChooseRole;



// WEBPACK FOOTER //
// ./src/pages/auth/ChooseRole/index.js